import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-color-swatch',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="d-flex align-items-center">
            <div [style.backgroundColor]="color" class="color-swatch rounded border d-inline-block align-middle mx-2"></div>
            @if (text) {
                <span>{{ text }}</span>
            }
            <ng-content></ng-content>
        </div>
    `,
    styles: [`
        .color-swatch {
            width: 20px;
            height: 20px;
        }
    `]
})
export class ColorSwatchComponent {
    @Input() color: string | undefined;
    @Input() text: string | undefined;
}
